import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import BaseLink from "../common/base-link/base-link";
interface IGlossaryLetterProps {
  letter: string;
  isSelected?: boolean;
  isDisabled?: boolean;
}
const GlossaryLetter = props => {
  const $ = _c(6);
  const {
    letter,
    isSelected,
    isDisabled
  } = props;
  if (isDisabled) {
    let t0;
    if ($[0] !== letter) {
      t0 = <span className="ml-[5px] mr-[5px] w-9 rounded-full font-semibold md:text-[24px] capitalize flex items-center justify-center cursor-not-allowed text-gray-400">{letter}</span>;
      $[0] = letter;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  }
  const t0 = `/glossary${isSelected ? "" : `?letter=${letter}`}`;
  const t1 = `${"ml-[5px] mr-[5px] w-9 rounded-full font-semibold md:text-[24px] capitalize flex items-center justify-center"} ${isSelected ? "bg-[#00698f] !text-white" : "text-[#373A36] hover:text-[#005472] hover:underline"}`;
  let t2;
  if ($[2] !== letter || $[3] !== t0 || $[4] !== t1) {
    t2 = <BaseLink href={t0} className={t1}>{letter}</BaseLink>;
    $[2] = letter;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default GlossaryLetter;